import React, { useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { API_BASE_URL } from "../../../config";
import "../../../stylesheets/passwordReset.css";

Modal.setAppElement("#root");

export const ForgotPasswordModal = ({ modalIsOpen, modalIsClose }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [mailsend, setMailSend] = useState(false);
  const [isError, setIsError] = useState(false);

  const resetModalState = () => {
    setEmail("");
    setMessage("");
    setMailSend(false);
    setIsError(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (mailsend) return;
    setMailSend(true);
    setMessage("");
    setIsError(false);

    try {
      const response = await axios.post(`${API_BASE_URL}/users/requestPasswordReset`, {
        Email: email
      });
       if (response.status === 200) {
        setMessage(
            "Votre demande est envoyée. Si l'adresse que vous avez fournie correspond à un compte existant, vous recevrez un e-mail contenant les instructions pour réinitialiser votre mot de passe. Veuillez vérifier votre boîte de réception et suivre les instructions. N'oubliez pas de vérifier vos spams."
        );
        setTimeout(() => {
          modalIsClose();
          resetModalState();
        }, 50000);
      }
    } catch (error) {
      if (
        error.response &&
        error.response?.status === 404 &&
        error.response.data?.error === "USER_NOT_FOUND"
      ) {
        setIsError(true);
        setMessage("Aucun compte n’est associé à cette adresse e-mail.");
      } else {
        setIsError(true);
        setMessage("Une erreur est survenue. Veuillez réessayer.");
      }
    } finally {
      setMailSend(false);
    }
  };

  const handleClose = () => {
    modalIsClose();
    resetModalState();
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={handleClose}
      className="password-reset-card password-reset-modal"
      overlayClassName="password-reset-overlay"
      aria={{ labelledby: "forgot-password-title" }}
    >
      <button type="button" className="password-reset-close" aria-label="Fermer" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </button>

      <h2 id="forgot-password-title">Mot de passe oublié ?</h2>

      <form className="password-reset-form" onSubmit={handleSubmit} aria-busy={mailsend}>
        <p className="password-reset-intro">
          Cette procédure de récupération de mot de passe concerne <b>exclusivement les abonnés à la Solution Digitale Langloÿs</b>.
          Merci d'indiquer votre adresse e-mail ci-dessous. Si celle-ci correspond à un compte existant, vous recevrez un e-mail avec un lien pour réinitialiser votre mot de passe.
        </p>

        <div className="password-reset-field">
          <label htmlFor="forgot-password-email">Adresse e-mail</label>
          <div className="password-reset-input-wrap">
            <input
              id="forgot-password-email"
              name="email"
              type="email"
              autoComplete="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              disabled={mailsend}
              required
            />
          </div>
        </div>

        <button type="submit" className="password-reset-button" disabled={mailsend}>
          {mailsend ? "Envoi en cours…" : "Envoyer"}
        </button>

        {message && (
          <p className={`password-reset-feedback ${isError ? "is-error" : "is-success"}`} role={isError ? "alert" : "status"}>
            {message}
          </p>
        )}

        <p className="password-reset-help">
          <b>Si vous souhaitez commander des Barèmes Rapides ou tout autre produit,</b> rendez vous sur notre site en ligne{" "}
          <a href="https://editionslangloys.com/" target="_blank" rel="noopener noreferrer" className="password-reset-link">
            Les Éditions Langloÿs
          </a>
        </p>
      </form>

      <footer className="password-reset-support">
        <p>Adresse non reconnue ? Contactez-nous :</p>
        <div>
          <a href="mailto:support@langloys.com">support@langloys.com</a>
          <span aria-hidden="true">·</span>
          <a href="tel:+33491251338">04 91 25 13 38</a>
        </div>
      </footer>
    </Modal>
  );
};
